module.exports = __webpack_public_path__ + "static/media/header_web_desktop_-_ver2-1.f4a6f65d.png";